
import React from 'react';
import { DocumentWithRelations } from '@/types/custom-types';

export interface DocumentDetailHeaderProps {
  document: DocumentWithRelations;
  onShare: () => void;
  onDownload: () => void;
  onDelete: () => void;
  confirmDelete: () => void;
}

export function DocumentDetailHeader({ document, onShare, onDownload, onDelete, confirmDelete }: DocumentDetailHeaderProps) {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Document Information</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p className="text-sm font-medium text-muted-foreground">Title</p>
          <p className="text-sm">{document.title}</p>
        </div>
        
        <div>
          <p className="text-sm font-medium text-muted-foreground">Created</p>
          <p className="text-sm">{new Date(document.created_at).toLocaleDateString()}</p>
        </div>
        
        <div>
          <p className="text-sm font-medium text-muted-foreground">Last Updated</p>
          <p className="text-sm">{new Date(document.updated_at).toLocaleDateString()}</p>
        </div>
        
        <div>
          <p className="text-sm font-medium text-muted-foreground">Status</p>
          <p className="text-sm capitalize">{document.status || 'Active'}</p>
        </div>
        
        {document.description && (
          <div className="col-span-1 md:col-span-2">
            <p className="text-sm font-medium text-muted-foreground">Description</p>
            <p className="text-sm">{document.description}</p>
          </div>
        )}
      </div>
    </div>
  );
}
